export const contact = {
  modal: {
    remove: {
      content: `Are you sure you want to delete contact <b>{contact}<b>?`
    }
  },

  form: {
    title: {
      edit: {
        main: 'Contact data'
      }
    }
  },

  table: {
    field: {
      first_name: 'First name',
      last_name: 'Last name',
      full_name: 'Full name',
      email: 'Email',
      contact_methods: 'Contact methods',
      contact_method: 'Contact method',
      label: 'Icon'
    }
  }
};
